import { Stack } from "@mui/material";
import SettingCard from "@/components/SettingCard";
import ClassSettings from "@/components/editor/settings/ClassSettings";
import IndexSettings from "@/components/editor/settings/IndexSettings";
import SpacingSettings from "@/components/editor/settings/SpacingSettings/SpacingSettings";
import SectionTransitionSetting from "@/components/editor/settings/SectionTransitionSetting";
import BackgroundSettings from "@/components/editor/settings/BackgroundSettings/BackgroundSettings";

export const SectionSettings = () => {
    return (
      <Stack spacing={2}>
        {/* ✅ */}
        <SettingCard title="Clase Css">
          <ClassSettings />
        </SettingCard>
        <SettingCard title="Padding">
          <SpacingSettings margin={false} />
        </SettingCard>
        <SettingCard title="Fondo">
          <BackgroundSettings />
        </SettingCard>
        {/* ❌ */}
        <SettingCard title="Indice">
          <IndexSettings />
        </SettingCard>
        <SettingCard title="Transición">
          <SectionTransitionSetting />
        </SettingCard>
      </Stack>
    );
};

export default SectionSettings;
